import { Box, Stack, Typography } from '@mui/material';
import prismLogo from '../../shared/assets/prismai-logo.svg';

const Header = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{
        px: 2.5,
        py: 1.5,
        borderBottom: '1px solid #e2e2e2',
      }}
    >
      <Box component="img" src={prismLogo} alt="Prism AI" sx={{ height: 28, width: 'auto' }} />
      <Typography variant="h6" sx={{ fontSize: '1.05rem', fontWeight: 600, color: '#444' }}>
        Delivery Agent
      </Typography>
    </Stack>
  );
};

export default Header;
